var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'swiper'
    ]},[_c('div',{ref:"gabarit",staticClass:"gabarit"},_vm._l((_vm.data),function(market,i){return _c('span',{key:market.id,ref:"market",refInFor:true,staticClass:"caption"},[_c('a',{class:{
                    'router-link-exact-active': i == _vm.index
                }},[_vm._v(_vm._s(market.name))])])}),0),_c('router-link',{staticClass:"previous",attrs:{"to":_vm.$trl({
            name: 'Markets',
            params: {
                locale: _vm.$route.params.locale
            }
        })}},[_c('IconArrow',{staticClass:"icon",attrs:{"direction":'left',"color":'#FFFFFF',"width":"32","height":"27"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }